import { GqlGetRewardsV2Query, useGetRewardsV2Query } from 'types/graphql';
import { formatBirthdayForRewards } from 'shared/helpers/rewards';
import { ApolloQueryResult } from 'apollo-client';

type UseGetRewardsProps = {
  dispensaryId?: string;
  enterpriseId?: string;
  isoRegionCode?: string;
  birthday: string;
  pin: string;
  phone: string;
  skip?: boolean;
  customerId?: string;
};

type UseGetRewardsReturn = {
  data: GqlGetRewardsV2Query | undefined;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<GqlGetRewardsV2Query>>;
};

export const useGetRewards = ({
  dispensaryId,
  enterpriseId,
  isoRegionCode,
  birthday,
  pin = '',
  phone,
  skip = false,
  customerId,
}: UseGetRewardsProps): UseGetRewardsReturn => {
  const skipQuery = skip || (!dispensaryId && !enterpriseId);
  const dob = formatBirthdayForRewards(birthday);

  const { data, loading, refetch } = useGetRewardsV2Query({
    variables: {
      phoneNumber: phone,
      dispensaryId,
      enterpriseId,
      isoRegionCode,
      dob,
      pin,
      customerId,
    },
    fetchPolicy: 'network-only',
    skip: skipQuery,
  });

  return {
    data,
    loading,
    refetch,
  };
};
